import { SetDrawerDataPayload } from './actions';
import { DetailsDrawerState } from './types';

const setDrawerData = (
  state: DetailsDrawerState,
  { scopeData, componentId }: SetDrawerDataPayload
): DetailsDrawerState => ({
  ...state,
  scopeData,
  componentId,
});

const setBusinessCriticalFieldIds = (
  state: DetailsDrawerState,
  businessCriticalFieldIds: string[]
): DetailsDrawerState => ({
  ...state,
  businessCriticalFieldIds,
});

export const detailsDrawerOperations = {
  setDrawerData,
  setBusinessCriticalFieldIds,
};
